Auth = require 'db/auth'
Backbone = require 'backbone'
ModelCache = require 'db/model-cache'
getExperiment = require 'lib/experiments/simple-test'
modelCache = require 'db/model-cache'
trackUe = require 'debug/trackUe'
_ = require 'underscore'

class SimplifiedStateManager
  _.extend @prototype, Backbone.Events

  FEATURES = [
    'org-settings'
    'card-activity'
    'card-move'
    'labels-and-edit'
  ]

  constructor: ->
    # We want to attach a listener to the model cache after we load the current
    # logged-in user from the api, not every time we load a member.
    @subscribed = false
    modelCache.on 'add:Member', (action) =>
      return if @subscribed || !Auth.me()?

      @listenTo modelCache, 'add:Action', @registerAction
      @listenTo Auth.me().organizationList, 'add', @registerAction
      @listenTo Auth.me().boardList, 'add', @registerAction

      @subscribed = true

  registerAction: ->
    if !Auth.me().isDismissed("simplified-view-full-view") && @_fullViewIsUnlocked()
      # we use dismissals to make unlocking features persistent across sessions
      Auth.me().dismiss('simplified-view-full-view')
      @trigger 'full-view:unlocked'
      return

    for feature in FEATURES
      if !Auth.me().isDismissed("simplified-view-#{ feature }") && @isUnlocked(feature)
        Auth.me().dismiss("simplified-view-#{ feature }")
        @trigger "#{ feature }:unlocked"

  _isMemberOfMultiMemberBoard: ->
    for board in Auth.me().boardList.models
      if board.memberList.length > 1
        return true
    return false

  _hasCreatedNumCards: (threshold) ->
    count = 0
    for board in Auth.me().boardList.models
      for list in board.listList.models
        count += list.cardList.length
        return true if count >= threshold
    return false

  _fullViewIsUnlocked: ->
    !getExperiment('simplifiedView').get('enabled') ||
    Auth.me().isDismissed('simplified-view-full-view') ||
    @_hasCreatedNumCards(6) ||
    @_isMemberOfMultiMemberBoard()

  isUnlocked: (feature) ->
    return true if @_fullViewIsUnlocked() || Auth.me().isDismissed("simplified-view-#{ feature }")

    switch feature
      when 'org-settings'
        Auth.me().organizationList.length > 0
      when 'labels-and-edit'
        @_hasCreatedNumCards(2)
      when 'card-move'
        Auth.me().boardList.length > 1
      when 'card-activity'
        for action in Auth.me().getActions()
          return true if action.get('type') == 'commentCard'
        false

module.exports = new SimplifiedStateManager()



// WEBPACK FOOTER //
// ./app/scripts/lib/simplified-state-manager.coffee